import { render } from "./form-realisasi.vue?vue&type=template&id=22a1b952"
import script from "./form-realisasi.vue?vue&type=script&lang=js"
export * from "./form-realisasi.vue?vue&type=script&lang=js"
script.render = render

export default script